import React from 'react';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

/**
 * ErrorBoundary wrapper for React Router route elements.
 * Renders nested routes via <Outlet /> while providing error boundary protection.
 * 
 * Used to protect tenant portal routes from rendering errors.
 * Platform Admin routes have their own separate ErrorBoundary.
 */
export const TenantErrorBoundaryWrapper: React.FC = () => {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
};

export default TenantErrorBoundaryWrapper;
